/**
 * Combined LGZ Q&A set (Wave 1 + Wave 2), de-duplicated by slug.
 * All /lgz question surfaces (hub, /lgz/q/$slug, JSONL feed, sitemap)
 * read from here so a new wave lands everywhere at once.
 */
import { LGZ_QA, type LgzQA } from "./questions-500";
import { LGZ_QA_WAVE2 } from "./questions-wave2";
import { LGZ_QA_WAVE3 } from "./questions-wave3";
import { liftToFloor } from "../_qa/topup-merge";
import { LGZ_TOPUP_AXIS } from "../_qa/topup-axes";

const merged: LgzQA[] = [];
const seen = new Set<string>();
for (const qa of [...LGZ_QA, ...LGZ_QA_WAVE2, ...LGZ_QA_WAVE3]) {
  if (seen.has(qa.slug)) continue;
  seen.add(qa.slug);
  merged.push(qa);
}

liftToFloor<LgzQA["cluster"], LgzQA>(merged, {
  prefix: "lgz-t7",
  asOf: "ข้อมูลทบทวน ณ สิงหาคม 2569 ค่าธรรมเนียม ช่องทางยื่น และคิวของแต่ละสถานทูตเปลี่ยนได้ ควรตรวจ consular.mfa.go.th ก่อนเดินเรื่อง เว็บไซต์ไม่แสดงค่าบริการ ขอใบเสนอราคาเฉพาะเคสได้ทางโทรศัพท์ LINE หรืออีเมล",
  authorityTh: "กองสัญชาติและนิติกรณ์ กรมการกงสุล และสถานทูตปลายทาง",
  clusterTh: "งานรับรองเอกสารกงสุล (นิติกรณ์)",
  primary: LGZ_TOPUP_AXIS,
  clusters: { documents: "documents", process: "process", risk: "problem", location: "location" },
});

export const LGZ_QA_ALL: LgzQA[] = merged;

export const LGZ_QA_ALL_BY_SLUG: Record<string, LgzQA> = Object.fromEntries(
  LGZ_QA_ALL.map((q) => [q.slug, q]),
);

/** Total distinct phrasings covered (question + synonym clusters). */
export const LGZ_QA_PHRASING_COUNT = LGZ_QA_ALL.reduce(
  (n, qa) => n + 1 + qa.synonyms.length,
  0,
);
